export enum GradingCenterModalState {
  CLOSED = "CLOSED",
  VIEW_ASSIGNMENT_RESPONSE = "VIEW_ASSIGNMENT_RESPONSE",
  VIEW_ASSESSMENT_RESPONSE = "VIEW_ASSESSMENT_RESPONSE",
  VIEW_PROJECT_RESPONSE = "VIEW_PROJECT_RESPONSE",
}
